import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type StoreService from 'ember-data/store';
import type SessionContextService from 'tio-employee/services/session-context';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export default class AuthenticatedTuitionAssistanceDependentProgramsRoute extends Route {
  @service declare store: StoreService;
  @service declare sessionContext: SessionContextService;
  @service declare reimaginedData: ReimaginedDataService;

  async model() {
    const currentEmployee = this.sessionContext.currentEmployee;
    const employeeId = currentEmployee.id as string;

    const [tasData, employee] = await Promise.all([
      this.reimaginedData.fetchDependentTasData(),
      this.store.findRecord('employee', employeeId, {
        include: 'dependents',
        reload: true,
      }),
    ]);

    // Compute enrolled template IDs from the dependent applications
    const enrolledTemplateIds = new Set(
      tasData.applications
        .filter((app) => app.programTemplateId)
        .map((app) => app.programTemplateId as string)
    );

    const eligibleTemplates =
      await this.reimaginedData.fetchDependentEligibleTemplates(enrolledTemplateIds);

    return {
      tasData,
      eligibleTemplates,
      employee,
    };
  }
}
